/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Encoding_OptionsInputs */

const en_subtitle_export_encoding_options = /** @type {(inputs: Subtitle_Export_Encoding_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encoding Options`)
};

const fr_subtitle_export_encoding_options = /** @type {(inputs: Subtitle_Export_Encoding_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Options d'encodage`)
};

const de_subtitle_export_encoding_options = /** @type {(inputs: Subtitle_Export_Encoding_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kodierungsoptionen`)
};

const it_subtitle_export_encoding_options = /** @type {(inputs: Subtitle_Export_Encoding_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opzioni di codifica`)
};

const ru_subtitle_export_encoding_options = /** @type {(inputs: Subtitle_Export_Encoding_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Параметры кодирования`)
};

const es_subtitle_export_encoding_options = /** @type {(inputs: Subtitle_Export_Encoding_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opciones de codificación`)
};

const zh_cn2_subtitle_export_encoding_options = /** @type {(inputs: Subtitle_Export_Encoding_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`编码选项`)
};

const ja_subtitle_export_encoding_options = /** @type {(inputs: Subtitle_Export_Encoding_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エンコードオプション`)
};

const hi_subtitle_export_encoding_options = /** @type {(inputs: Subtitle_Export_Encoding_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एन्कोडिंग विकल्प`)
};

const pt_pt2_subtitle_export_encoding_options = /** @type {(inputs: Subtitle_Export_Encoding_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opções de codificação`)
};

/**
* | output |
* | --- |
* | "Encoding Options" |
*
* @param {Subtitle_Export_Encoding_OptionsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_encoding_options = /** @type {((inputs?: Subtitle_Export_Encoding_OptionsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Encoding_OptionsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_export_encoding_options(inputs)
	if (locale === "de") return de_subtitle_export_encoding_options(inputs)
	if (locale === "it") return it_subtitle_export_encoding_options(inputs)
	if (locale === "ru") return ru_subtitle_export_encoding_options(inputs)
	if (locale === "es") return es_subtitle_export_encoding_options(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_export_encoding_options(inputs)
	if (locale === "ja") return ja_subtitle_export_encoding_options(inputs)
	if (locale === "hi") return hi_subtitle_export_encoding_options(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_export_encoding_options(inputs)
	return en_subtitle_export_encoding_options(inputs)
});